import { useState } from "react";

// Reserved logo slot: drop your logo file at frontend/public/logo.png and it
// appears here automatically. Until then the built-in Aircon mark is shown.
export default function Logo({ size = 44 }) {
  const [customFailed, setCustomFailed] = useState(false);

  if (!customFailed) {
    return (
      <img
        src="/logo.png"
        alt="Aircon Travel logo"
        data-testid="brand-logo"
        onError={() => setCustomFailed(true)}
        className="object-cover shrink-0 rounded-full"
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <span
      className="inline-flex items-center justify-center bg-signal shrink-0"
      style={{ width: size, height: size, borderRadius: size * 0.22 }}
      aria-hidden="true"
    >
      <svg width={size * 0.62} height={size * 0.62} viewBox="0 0 64 64" fill="none">
        <path d="M16 46 L44 18" stroke="#0A0A0C" strokeWidth="7" strokeLinecap="square" />
        <path d="M44 18 H27 M44 18 V35" stroke="#0A0A0C" strokeWidth="7" strokeLinecap="square" />
      </svg>
    </span>
  );
}
